import Vue from 'vue'
import CenteredLoadingIndicator from '@/components/CenteredLoadingIndicator'

Vue.component('CenteredLoadingIndicator', CenteredLoadingIndicator)
